<div class="app-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2>{{ 'domains.addDomainTitle' | translate }}</h2>
    </div>
    <button mat-icon-button type="button" (click)="onCancel()" [attr.aria-label]="'cancel' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body">
    <form [formGroup]="form" (submit)="onSubmit()">
      <div class="form-field">
        <label class="field-label">{{ 'domains.domain' | translate }}</label>
        <mat-form-field appearance="outline">
          <input type="text" matInput formControlName="domain" [errorStateMatcher]="errorStateMatcher">
          <mat-error *ngIf="form.hasError('required', ['domain'])">
            {{ 'fieldRequired' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div class="form-field">
        <label class="field-label">{{ 'domains.googleAdminEmail' | translate }}</label>
        <mat-form-field appearance="outline">
          <input type="email" matInput formControlName="googleAdminEmail" [errorStateMatcher]="errorStateMatcher">
          <mat-error *ngIf="form.hasError('required', ['googleAdminEmail'])">
            {{ 'fieldRequired' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

    </form>
  </div>

  <footer class="app-dialog__footer">
    <button mat-stroked-button type="button" (click)="onCancel()" [disabled]="loading">{{ 'cancel' | translate }}</button>
    <button mat-raised-button color="primary" type="button" (click)="onSubmit()" [disabled]="loading">
      <mat-icon *ngIf="!loading">add</mat-icon>
      <mat-spinner diameter="20" class="dc-btn-spinner" *ngIf="loading"></mat-spinner>
      <span *ngIf="!loading">{{ 'add' | translate }}</span>
    </button>
  </footer>
</div>
